import { Card, Box, Typography, Button } from "@mui/material";
import { DownloadOutlined } from "@mui/icons-material";
import dayjs from "dayjs";
import BenefitCard from "../BenefitCard";
import React from "react";
import ProgressCard from "../ProgressCard";
import InfoRow from "../InfoRow";

const PolicySection = ({ policy, index }) => {
    return (
        <Box sx={{ mb: 2, borderBottom: `1px dashed #0000001a`, pb: 2 }}>
            <Box sx={{ borderBottom: `1px dashed #0000001a`, pb: 2, mb: 2 }}>
                {policy?.sum_assured && <InfoRow label="Sum Assured" value={policy?.sum_assured} />}
                {policy?.beneficiary_details && <BeneficiaryDetails beneficiary={policy.beneficiary_details} index={index} />}
                {policy?.policy_id && <InfoRow label="Policy Number" value={policy?.policy_id} />}
                {policy?.effective_Date && <InfoRow label="Effective Date" value={dayjs(policy?.effective_Date).format("MMMM DD, YYYY")} />}
                {policy?.expiry_date && <InfoRow label="Expiry Date" value={dayjs(policy?.expiry_date).format("MMMM DD, YYYY")} />}
            </Box>
            {policy.nominee_details?.length > 0 && <NomineeDetails nomineeDetails={policy.nominee_details} />}
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>Documents</Typography>
            <Button variant="outlined" startIcon={<DownloadOutlined />} sx={{ mt: 1, mr: 1 }}>Policy Document</Button>
            <Button variant="outlined" startIcon={<DownloadOutlined />} sx={{ mt: 1 }}>E Card</Button>
        </Box>
    );
};
const BeneficiaryDetails = ({ beneficiary, index }) => (
    <React.Fragment key={index}>
        {beneficiary?.beneficiary_name && <InfoRow label="Beneficiary Name" value={beneficiary?.beneficiary_name} />}
        {beneficiary?.beneficiary_dob && <InfoRow label="Beneficiary D.O.B" value={dayjs(beneficiary?.beneficiary_dob).format("MMMM DD, YYYY")} />}
        {beneficiary?.id_proof && <InfoRow label="Government ID Uploaded" value={beneficiary?.id_proof} />}
    </React.Fragment>
);
const NomineeDetails = ({ nomineeDetails }) => (
    <>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>Nominee Details</Typography>
        {nomineeDetails.map((nominee, idx) => (
            <Box key={idx} sx={{ borderBottom: "1px dashed #ddd", pb: 1, mb: 2 }}>
                <InfoRow label="Nominee Name" value={nominee.nominee_name} />
                <InfoRow label="Nominee D.O.B" value={dayjs(nominee.nominee_dob).format("MMMM DD, YYYY")} />
                <InfoRow label="Nominee ID Uploaded" value={nominee.id_proof} />
            </Box>
        ))}
    </>
);
const LIMICard = ({ benefitDetails, policyDetails, clubProgressDetails }) => {
    return (
        <Box sx={{ p: 2 }}>
            <Card sx={{ p: 2, boxShadow: 'none', border: `1px dashed #0000001a`, mb: 2 }}>
                <ProgressCard ProgressDetails={clubProgressDetails} />
            </Card>
            <Card sx={{ p: 3, boxShadow: 'none', border: `1px dashed #0000001a`, mb: 2 }}>
                <BenefitCard benefitDetails={benefitDetails} />
                {policyDetails.map((policy, index) => (
                    <PolicySection key={index} policy={policy} index={index} />
                ))}
            </Card>
        </Box>
    );
};
export default LIMICard;
